import { baseApi } from "./baseApi";

export interface FleetResult {
  id: string;
  vehicle_type: string;
  license_plate: string;
  vin: string;
  model_id: string;
  [key: string]: any;
}

export interface ServiceResult {
  id: string;
  description: string;
  vehicle_type: string;
  [key: string]: any;
}

export interface BranchResult {
  id: string;
  branch_name: string;
  branch_address: string;
  branch_email: string;
  branch_phone: string;
  [key: string]: any;
}

export interface OrderResult {
  id: string;
  order_number: string;
  status: string;
  order_type: string;
  [key: string]: any;
}

export interface UserResult {
  id: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  role?: string | { name: string };
  [key: string]: any;
}

export interface SearchResults {
  fleet: FleetResult[];
  services: ServiceResult[];
  branches: BranchResult[];
  orders: OrderResult[];
  users: UserResult[];
}

export interface SearchResponse {
  query: string;
  category: string;
  results: SearchResults;
}

export type SearchCategory = "all" | "fleet" | "services" | "branches" | "orders" | "users";

const searchApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    globalSearch: builder.query<SearchResponse, { query: string; category?: SearchCategory }>({
      query: ({ query, category = "all" }) => {
        const params = new URLSearchParams();
        params.append("query", query);
        params.append("category", category);
        return { url: `/search?${params.toString()}`, method: "GET" };
      },
      transformResponse: (response: any) => response?.data ?? response,
      keepUnusedDataFor: 30,
    }),
  }),
  overrideExisting: false,
});

export const { useGlobalSearchQuery } = searchApi;
